import {
  CognitoAccessToken,
  CognitoIdToken,
  CognitoRefreshToken,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import { Auth } from "aws-amplify";

export const getAccessJwtToken = async (): Promise<string> => {
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
};

export const getRefreshToken = async (): Promise<string> => {
  const session = await Auth.currentSession();
  return session.getRefreshToken().getToken();
};

export const getUserInfo = async (): Promise<any> => {
  return await Auth.currentUserInfo();
};

export async function updateAmplifySession({
  idToken,
  accessToken,
  refreshToken,
}: any): Promise<void> {
  const cognitoIdToken = new CognitoIdToken({ IdToken: idToken });
  const cognitoAccessToken = new CognitoAccessToken({
    AccessToken: accessToken,
  });
  const cognitoRefreshToken = new CognitoRefreshToken({
    RefreshToken: refreshToken,
  });
  const session = new CognitoUserSession({
    IdToken: cognitoIdToken,
    AccessToken: cognitoAccessToken,
    RefreshToken: cognitoRefreshToken,
  });

  const user: any = await Auth.currentAuthenticatedUser();
  user.setSignInUserSession(session);
}
